// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__2sz5g","OctoNavBar":"styles_OctoNavBar__2JcNG","OctoFooter":"styles_OctoFooter__3zd8N"};